import { assert_is_safe_number, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { TutorialProgressKey } from '@shared/types/types';
import { ENUM__dto_class_name } from '../../../serialization/ENUM__dto_class_name';
import { DTO__database_entity } from '../../_database_entity/DTO__database_entity';

//id = user_id
export class DTOUserTutorialProgress extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.USER_TUTORIAL_PROGRESS;

  //trigget complete
  /*
   * To implement toast you need implement following parts:
   * 1. trigger
   * 2. reads toast
   * 3. view
   */
  static readonly KEYS_BOOLEAN = [
    /*
     * TOASTS
     */
    'toast_generation_contains_already_generated_images', //? ? ?
  ] as const satisfies readonly TutorialProgressKey[];

  static readonly KEYS_KEYOBARD_HINTS_NUMBER = [] as const satisfies readonly TutorialProgressKey[];

  /*
   * GENERATION
   */

  /*
   * TOASTS
   */

  toast_generation_contains_already_generated_images!: boolean;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    for (let key of DTOUserTutorialProgress.KEYS_BOOLEAN) {
      assert_type_boolean(this[key]);
    }

    for (let key of DTOUserTutorialProgress.KEYS_KEYOBARD_HINTS_NUMBER) {
      assert_is_safe_number(this[key]);
    }
  }
}

export const CLASS_FIELDS_USER_TUTORIAL_PROGRESS_HINT = Object.keys(new DTOUserTutorialProgress()).filter(key => key.startsWith('hint_'));
